module.exports = __webpack_public_path__ + "static/media/online-pin.f271c3b5.svg";